import React, { useState } from 'react';
import { Modal, Button, Alert, Spinner } from 'react-bootstrap';
import { FiRefreshCw, FiMail } from 'react-icons/fi';
import { adminService } from '../../services/adminService';

const ResetPasswordModal = ({ show, onHide, admin, onSuccess }) => {
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState(null);

  const handleReset = async () => {
    if (!admin) return;
    setLoading(true);
    setError(null);
    try {
      await adminService.requestPasswordReset(admin.id);
      onSuccess(`Un email de réinitialisation a été envoyé à ${admin.email}`);
      onHide();
    } catch (err) {
      setError(err.response?.data?.error || "Une erreur est survenue lors de la réinitialisation.");
    } finally {
      setLoading(false);
    }
  };

  return (
    <Modal show={show} onHide={onHide} centered>
      <Modal.Header closeButton>
        <Modal.Title className="d-flex align-items-center gap-2">
          <FiRefreshCw className="text-primary" /> Réinitialiser le mot de passe
        </Modal.Title>
      </Modal.Header>
      <Modal.Body className="p-4">
        {error && <Alert variant="danger">{error}</Alert>}
        
        <div className="text-center mb-4">
            <div className="bg-light rounded-circle d-inline-flex p-4 mb-3">
                <FiMail size={40} className="text-secondary" />
            </div>
            <h5 className="fw-bold">{admin?.name}</h5>
            <p className="text-muted small">{admin?.email}</p>
        </div>

        <p className="text-center">
          Voulez-vous vraiment réinitialiser le mot de passe de cet administrateur ? 
          Un lien sécurisé lui sera envoyé par email.
        </p>

        <div className="d-flex gap-3 justify-content-center mt-4">
          <Button variant="light" onClick={onHide} disabled={loading}>
            Annuler
          </Button>
          <Button 
            variant="primary" 
            onClick={handleReset} 
            disabled={loading}
            className="d-flex align-items-center gap-2"
          >
            {loading ? <Spinner size="sm" /> : <FiRefreshCw />}
            Confirmer la réinitialisation
          </Button>
        </div>
      </Modal.Body>
    </Modal>
  );
};

export default ResetPasswordModal;
